import React, { useState, useEffect } from "react";
import { Header } from "../header/Header";
import "./Game.scss";
import GameTab from "../GameTab/GameTab";
import GameThumbnailComponent from "../GameThumbnail/GameThumbnailComponent";
import GameIFrameComponent from "../GameIFrame/GameIFrameComponent";
import { GameBannerDetails, NO_GAME_AVAILABLE } from "./Constant";
import ScoreTableList from "./ScoreTable";
import Footer from "../footer/Footer";
import { getToken } from "../../apis/util";
import { useScrollReveal } from "../../motion/useScrollReveal";
import { usePagePreload } from "../../preload/usePagePreload";
import { GAME_IMAGES } from "../../preload/pageAssets";
import PageSkeleton from "../../preload/PageSkeleton";
import monchromaticimage from "../../assests/our_services_assets/p_img.jpg";

interface GameDetails {
  id: number;
  gameName: string;
  imageSource: string;
  title?: string;
  gameType: string;
  gameEnabled: boolean;
  currency: string;
  className: string;
}

const Game: React.FC = () => {
  const [tab, setTab] = useState<number>(1);
  const token = getToken();
  const [showGame, setShowGame] = useState<boolean>(false);
  const [gameId, setGameId] = useState<string>("");
  const [gameState, setGameState] = useState<boolean>(false);
  const [gamesList, setGamesList] = useState<GameDetails[]>([]);
  const [launchUrl, setLaunchUrl] = useState<string>("");

  // Step 1 of the entrance: the tab bar rises up (bottom to top) and fades in
  // as the section scrolls into view. It animates FIRST and alone here � the
  // thumbnail grid runs its own reveal (GameThumbnailComponent) with a delay so
  // the two never overlap.
  const sectionRef = useScrollReveal<HTMLDivElement>({
    selector: ".game-tab-bar",
  });

  const { ready } = usePagePreload(GAME_IMAGES);

  const openGame = (gameId: string, url: string): void => {
    setShowGame(true);
    setGameId(gameId);
  };

  const filterGamesData = (tab: number): void => {
    switch (tab) {
      case 1:
        setGamesList(GameBannerDetails);
        break;
      case 2:
        setGamesList(
          GameBannerDetails.filter((game) => game.gameType === "SlotGames")
        );
        break;
      case 3:
        setGamesList(
          GameBannerDetails.filter((game) => game.gameType === "TableGames")
        );
        break;
      case 4:
        setGamesList(
          GameBannerDetails.filter((game) => game.gameType === "CasualGames")
        );
        break;
      default:
        setGamesList([]);
        break;
    }
  };

  useEffect(() => {
    filterGamesData(tab);
  }, [tab]);

  // Extracted game content logic
  let gameContent;
  if (tab === 5) {
    gameContent = (
      <div className="ScoreBoardContainer">
        {token && <ScoreTableList />} 
      </div>
    );
  } else if (gamesList.length) {
    gameContent = (
      <GameThumbnailComponent
        clickEvent={openGame}
        gameState={gameState}
        setGameState={setGameState}
        gamesList={gamesList}
        setLaunchUrl={setLaunchUrl}
      />
    );
  } else {
    gameContent = <p className="no-game">{NO_GAME_AVAILABLE}</p>;
  }

  if (!ready) {
    return <PageSkeleton cards={6} />;
  }

  return (
    <div className="gameContainer">
      <Header />
      <div
        className="gameTabContainer"
        ref={sectionRef}
        style={{ backgroundImage: `url(${monchromaticimage})` }}
      >
        <GameTab tab={tab} setTab={setTab} />
        {gameContent}
        {showGame && (
          <GameIFrameComponent
            id={gameId}
            gameState={gameState}
            setGameState={setGameState}
            launchUrl={launchUrl}
          />
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Game;
